import { RadioButtonGroup } from 'components/uikit/RadioButtonGroup';
import { RadioButtonOption } from '../variableTypeSelector/VariableTypeSelector';

import styles from './VariableModalSelector.module.scss';

type VariableModalSelectorProps = {
  onChange: (selectedOption: string) => void;
  defaultValue?: RadioButtonOption;
  options: RadioButtonOption[];
  value: string;
  disabled?: boolean;
};

export const VariableModalSelector: React.FC<VariableModalSelectorProps> = (
  props,
) => {
  return (
    <RadioButtonGroup<RadioButtonOption, 'text'>
      rootClassName={styles.radioButtonGroup}
      options={props.options}
      value={props.value || props.defaultValue?.text!}
      valueField={'text'}
      labelField={'text'}
      disabled={props.disabled}
      onSelectedOptionChanged={(newOption) => {
        props.onChange(newOption.text);
      }}
    />
  );
};
